export const FEATURE_NAME = '@zerops/zerops/core/resource-statistics-base';
